import React, { useEffect, useState } from "react";
import { registerOrganization } from '../components/Api';
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import * as colors from "../assets/css/Colors";
// Loader
import Loader from '../components/Loader';

import Darkimg from '../assets/img/curve2.png';
import whiteimg from '../assets/img/curve1.png';
import Darkbg from '../assets/img/bg-1.webp';
import whitebg from '../assets/img/bg-1-light.webp';
import Darkloginimg from '../assets/img/login/login-orange.gif';
import whiteloginimg from '../assets/img/login/login-green.gif';
import Imagegif from "../components/Image_gif";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Header from '../layout/Header';
import Footer from '../layout/Footer'

const Registration = () => {


  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
};

  
  const navigate = useNavigate(); // Initialize useNavigate
  const lightloginURL = whiteloginimg;
  const darkloginURL = Darkloginimg;
  
    // erroe massage open popup 
  
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [messageInfo, setMessageInfo] = useState({ message: [], type: '' });
  
  
    const handleShow = (message, type = 'error', show = true) => {
      setMessageInfo({ message, type });
      setShow(show);
      if (type === 'success') {
        setTimeout(() => {
          setShow(false);
          navigate('/'); 
        }, 5000); 
      }
    };
  
    const [formData, setFormData] = useState({
        name: '',
        registration_number: '',
        username: '',
        email: '',
        password: '',
        mobilenumber: '',
    });
    const [error, setError] = useState(''); // Add error state
    const [successMessage, setSuccessMessage] = useState(null);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
    
      // Adjust value based on the input field
      let updatedValue = value;
    
      // Convert username to lowercase
      if (name === "username") {
        updatedValue = value.toLowerCase();
      }
    
      // Restrict mobile number to 10 digits
      if (name === "mobilenumber") {
        updatedValue = value.slice(0, 10);
      }
    
      // Update form data with modified value
      setFormData({
        ...formData,
        [name]: updatedValue,
      });
    };
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      setError(null);
      setSuccessMessage(null);
      setIsLoading(true); // Start loader
    
      // Prepare form data
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
      });
    
      try {
        const response = await registerOrganization(formData);
    
        if (response && response.username) {
          setFormData((prevData) => ({
            ...prevData,
            username: response.username,
          }));
    
          handleShow(["Registration successful!"], "success");
          resetForm();
        } else {
          handleShow(["Username not found in response"], "error");
        }
      } catch (error) {
        console.error("Error during form submission:", error);
    
        // Check if the error response contains validation errors
        if (error.response && error.response.data && error.response.data.error) {
          // Extract validation errors from the response
          const errors = error.response.data.error;
          const errorMessages = [];
    
          // Collect and flatten the error messages
          Object.keys(errors).forEach((field) => {
            errorMessages.push(...errors[field]);
          });
    
          handleShow(errorMessages, "error");
        } else {
          // Handle other types of errors
          const errorMessage = error.message || "An unexpected error occurred.";
          handleShow([errorMessage], "error");
        }
      } finally {
        setIsLoading(false); // Stop loader
      }
    };
    
    
    const resetForm = () => {
      setFormData({
      name: '',
      registration_number: '',
      username: '',
      email: '',
      password: '',
      mobilenumber: '',
      });
    };
    // other function
    // Define image URLs and color dark mode and light mode change image start funtion
    const lightImageURL = whiteimg;
    const darkImageURL = Darkimg;
  
    const lightBgURL = whitebg;
    const darkBgURL = Darkbg;
  
    const [colorScheme, setColorScheme] = useState(
      window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );
  
    useEffect(() => {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  
      const handleChange = (e) => {
        setColorScheme(e.matches ? 'dark' : 'light');
      };
  
      mediaQuery.addEventListener('change', handleChange);
  
      return () => {
        mediaQuery.removeEventListener('change', handleChange);
      };
    }, []);
  
    useEffect(() => {
      const element = document.querySelector(".ban-short-links");
      if (element) {
        element.classList.add("ani");
      }
    }, []);
    // Define image URLs and color dark mode and light mode change image end funtion
  
    //  gradient color Start
    const styles = {
      background: colorScheme === 'dark'
        ? `linear-gradient(90deg, ${colors.theme_black_color}, ${colors.theme_white_color} 95%)`
        : `linear-gradient(90deg, ${colors.theme_white_color}, ${colors.theme_black_color} 95%)`,
    };
  
    // isFocused input style start function
    const [focusedInput, setFocusedInput] = useState(null);
  
    const inputStyles = (isFocused) => ({
      borderColor: isFocused
        ? `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color
        }`
        : '#000',
      boxShadow: isFocused
        ? `none`
        : 'none',
      transition: 'border-color 0.3s', // Add more transitions as needed
    });
    // isFocused input style end function
    
    return (
        <div className='Do-digital'>
        {isLoading && <Loader />}
        <Header />
        <div className="str ind2-home login-page">
                <div className="hom-head" style={{ backgroundImage: `url(${colorScheme === 'light' ? lightBgURL : darkBgURL})` }}>
                    <Container>
                        <Row>
                            <div className="ban-tit">
                                <h1>
                                    <b>Are you an <span style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>Indian ?
                                        <img src={colorScheme === 'light' ? lightImageURL : darkImageURL} alt="sharp" />
                                    </span>
                                    </b>
                                    <br />
                                    <span style={{ lineHeight: '32px' }}>
                                        Do digital Indian Citizen Card make it easier to your identity and your Professional details
                                    </span>
                                </h1>
                            </div>
                        </Row>
                    </Container>
                </div>
            </div>
  
        <section className="mt-0 mb-60">
          <Container>
            <Row>
              <Col sm={6}>
                <div style={{ position: 'sticky', top: '100px' }}>
                <img src={colorScheme === 'light' ? lightloginURL : darkloginURL} alt="Do-Digital" />
                </div>
              </Col>
              <Col sm={6}>
                <div className="login-main">
                  <div style={styles} className="log-bor">&nbsp;</div>
                  <span style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }} className="steps">You can register your organization here.</span>
                  <div className="log log-1">
                    <div className="login login-new">
                    <p>Welcome to this exciting world. Let’s work together to make this world even more thrilling.</p>
                      {error && (
                        <div style={{ color: 'red' }}>
                          {error.general ? (
                            <p>{error.general}</p>
                          ) : (
                            Object.keys(error).map((key) => (
                              <div key={key}>
                                {error[key].map((message, index) => (
                                  <p key={index}>{message}</p>
                                ))}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                      {successMessage && <div style={{ color: 'green' }}>{successMessage}</div>}
                      <Form onSubmit={handleSubmit}>
                      <Row className="mb-3">
                                                <Form.Group controlId="formGridName">
                                                    <Form.Label>Organization Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        placeholder="Organization Name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        style={inputStyles(focusedInput === 'name')}
                                                        onFocus={() => setFocusedInput('name')}
                                                        onBlur={() => setFocusedInput(null)}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group controlId="formGridRegistrationNumber">
                                                    <Form.Label>Registration Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="registration_number"
                                                        placeholder="Registration Number"
                                                        value={formData.registration_number}
                                                        onChange={handleChange}
                                                        style={inputStyles(focusedInput === 'registration_number')}
                                                        onFocus={() => setFocusedInput('registration_number')}
                                                        onBlur={() => setFocusedInput(null)}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group controlId="formGridUsername">
                                                    <Form.Label>Username</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="username"
                                                        placeholder="Username"
                                                        value={formData.username}
                                                        onChange={handleChange}
                                                        style={inputStyles(focusedInput === 'username')}
                                                        onFocus={() => setFocusedInput('username')}
                                                        onBlur={() => setFocusedInput(null)}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group controlId="formGridEmail">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        placeholder="Email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        style={inputStyles(focusedInput === 'email')}
                                                        onFocus={() => setFocusedInput('email')}
                                                        onBlur={() => setFocusedInput(null)}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group controlId="formGridMobileNumber">
                                                    <Form.Label>Mobile Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="mobilenumber"
                                                        placeholder="Mobile Number"
                                                        value={formData.mobilenumber}
                                                        onChange={handleChange}
                                                        style={inputStyles(focusedInput === 'mobilenumber')}
                                                        onFocus={() => setFocusedInput('mobilenumber')}
                                                        onBlur={() => setFocusedInput(null)}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                                <Form.Group controlId="formGridPassword">
                                                    <Form.Label>Password</Form.Label>
                                                    <div className="position-relative">
                                                    <Form.Control
                                                        type={showPassword ? 'text' : 'password'}
                                                        name="password"
                                                        placeholder="Password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        style={inputStyles(focusedInput === 'password')}
                                                        onFocus={() => setFocusedInput('password')}
                                                        onBlur={() => setFocusedInput(null)}
                                                        required
                                                    />
                                                     <FontAwesomeIcon
                                                            icon={showPassword ? faEye : faEyeSlash}
                                                            onClick={togglePasswordVisibility}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '32px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </div>
                                                </Form.Group>                                                                                              
                                            </Row>
                         <Button variant="primary" type="submit" style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                         Register
                        </Button>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

  
         {/* First Popup */}
         <Modal
          show={show}
          onHide={() => setShow(false)}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className={`error_massage_header ${messageInfo.type}`}>
              {messageInfo.type === 'error' ? (
                <Imagegif text={'error'} />
              ) : (
                <Imagegif text={'successfully'} />
              )}
              {show && (
                <ul className={`error_massage_contet ${messageInfo.type}`}>
                  {messageInfo.message.map((msg, index) => (
                    <li key={index} className={`${messageInfo.type}_message`}>
                      {messageInfo.type === 'error' ? (
                        <span className="error_icon"></span>
                      ) : (
                        <div className="success_icon">
                          <h1>Thank You!</h1>
                        </div>
                      )}
                      {msg}
                    </li>
                  ))}
                </ul>
              )}
            </Modal.Title>
          </Modal.Header>
        </Modal>
        <Footer />
      </div>
    );
};

export default Registration;
